export default {"src":"/_next/static/media/orderFollowEmpty.ebca10c8.svg","height":152,"width":199,"blurWidth":0,"blurHeight":0};